import styled from '@emotion/styled';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const NotesV2 = (props) => {
  const { color, ...rest } = props;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon width="20" height="21" viewBox="0 0 20 21" {...rest}>
      <path
        d="M7.08398 12.5286H12.9173"
        stroke={color || '#3C4852'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08398 10.0286H12.9173"
        stroke={color || '#3C4852'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08398 7.52857H12.9173"
        stroke={color || '#3C4852'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0007 16.6952H5.00065C4.07982 16.6952 3.33398 15.9494 3.33398 15.0286V5.02857C3.33398 4.10773 4.07982 3.3619 5.00065 3.3619H15.0007C15.9215 3.3619 16.6673 4.10773 16.6673 5.02857V15.0286C16.6673 15.9494 15.9215 16.6952 15.0007 16.6952Z"
        stroke={color || '#3C4852'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

export default NotesV2;
